import { ProductService } from "../../../http/services/product";
import { SET_PRODUCTS, SET_PRODUCT } from "../../mutations.type";
import {
  FETCH_ALL_PRODUCTS,
  FETCH_PRODUCTS,
  FETCH_PRODUCT,
  CREATE_PRODUCT,
  UPDATE_PRODUCT,
  DELETE_PRODUCT
} from "../../actions.type";

export default {
  async [FETCH_PRODUCTS](context, params) {
    const resp = await ProductService.getAllBy(params);
    context.commit(SET_PRODUCTS, resp.data.products);
  },
  async [FETCH_ALL_PRODUCTS](context) {
    const resp = await ProductService.getAll();
    context.commit(SET_PRODUCTS, resp.data.products);
  },
  async [FETCH_PRODUCT](context, id) {
    const { data } = await ProductService.get(id);
    context.commit(SET_PRODUCT, data.product);
  },
  async [CREATE_PRODUCT](context, product) {
    await ProductService.create(product);
  },
  async [UPDATE_PRODUCT](context, product) {
    await ProductService.update(product);
  },
  async [DELETE_PRODUCT](context, product) {
    await ProductService.delete(product);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/product/actions.js